import PspButton from "@/components/pspButton/PspButton";
import { translate } from "@/config/translator";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
} from "@fluentui/react-components";
import { useFilePreviewDialog } from "./filePreviewDialog/useFilePreviewDialog";
import Skeleton from "react-loading-skeleton";
import { MissingPreviewPlaceholder } from "./filePreviewDialog/missingPreviewPlaceholder";
import {
  faFile,
  faFileCsv,
  faFileDoc,
  faFileExcel,
  faFileZip,
} from "@fortawesome/pro-light-svg-icons";
import { filesize } from "filesize";

type PspDocumentPreviewDialogProps = {
  onClose: () => void;
  onDownload: () => void;
  file: File | null | undefined;
  isOpen: boolean;
};

export default function FilePreviewDialog({
  file,
  onClose,
  onDownload,
  isOpen,
}: PspDocumentPreviewDialogProps) {
  const { lang, url, fileType } = useFilePreviewDialog({ file });

  return (
    <Dialog open={isOpen}>
      <DialogSurface className="w-[90vw]! max-w-300! h-[90vh]! max-h-300! py-2! px-4!">
        <DialogBody className="h-full">
          <DialogContent className="p-0!">
            {url && file ? (
              fileType !== undefined ? (
                <MissingPreviewPlaceholder
                  icon={
                    fileType === "csv"
                      ? faFileCsv
                      : fileType === "excel-spreadsheet"
                        ? faFileExcel
                        : fileType === "zip"
                          ? faFileZip
                          : fileType === "doc"
                            ? faFileDoc
                            : faFile
                  }
                  primaryText={file.name}
                  secondaryText={filesize(file.size)}
                />
              ) : (
                <iframe
                  key={url}
                  height="100%"
                  width="100%"
                  className="rounded-md"
                  src={url}
                />
              )
            ) : (
              <Skeleton width="100%" height="100%" />
            )}
          </DialogContent>
          <DialogActions className="pb-2.5">
            <PspButton appearance="secondary" onClick={onClose}>
              {translate("cancel", lang)}
            </PspButton>
            <PspButton
              disabled={!file}
              appearance="primary"
              onClick={onDownload}
            >
              {translate("download", lang)}
            </PspButton>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
